module.exports = __webpack_public_path__ + "img/google-maps.491c1d83.png";